import { SignupTicketingSystems } from "@/api/signup/signup.model";
import ducksImage from '../assets/ducks.png';


export interface OnboardingData {
    companyName: string;
    referralSource: typeof REFERRAL_OPTIONS[number]['value'];
    objectives: string;
    existingTicketingSystem?: SignupTicketingSystems;
}

export interface OnboardingModalProps {
    isOpen: boolean;
}

export interface ReferralOption {
    value: string;
    label: string;
}

export const REFERRAL_OPTIONS: ReferralOption[] = [
    { value: 'linkedin', label: 'LinkedIn' },
    { value: 'podcast', label: 'Podcast' },
    { value: 'cx2028', label: 'CX 2028' },
    { value: 'conferences', label: 'Conferences' },
    { value: 'google', label: 'Google' },
    { value: 'llm_engine', label: 'LLM engine' },
    { value: 'other', label: 'Other' },
];

export const DEFAULT_ONBOARDING_CONFIG = {
    backgroundImageUrl: ducksImage,
};
